<template>
    <el-table
      :data="reservations"
      stripe
      :height="height"
      style="width: 100%;"
      v-loading="loading"
      :cell-style="{padding:'2px'}">
      <div slot="empty">
        <span>{{$t('reservation.noReservation')}}</span>
      </div>
      <el-table-column
        fixed
        width="50">
        <template slot-scope="scope">
          <status-indicator class="ml-10"
          :negative="isNegative(scope.row.nb_days)"
          :intermediary="isIntermediary(scope.row.nb_days)"
          :positive="isPositive(scope.row.nb_days)"
            pulse
          />
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('reservation.reservationNumber')" prop="id" width="100" fixed>
        <template slot-scope="scope">
            <i v-if="!qtyValid(scope.row)" class="mdi mdi-alert">&nbsp;</i>
          <PortausLink path="/reservations/" :id="scope.row.id" :label="scope.row.id.toString()" fs="fs-12"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column v-if="showCustomer" :label="$i18n.t('reservation.customer')" prop="customer.usual_name" sortable show-overflow-tooltip>
        <template slot-scope="scope">
          <PortausLink path="/customers/" :id="scope.row.customer.id" :label="customerName(scope.row.customer)" fs="fs-12"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column v-if="showRep" :label="$i18n.t('reservation.rep')" sortable prop="sales_rep.first_name" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="word-break:break-word;" v-if="scope.row.sales_rep">{{scope.row.sales_rep.first_name}} {{scope.row.sales_rep.last_name}}</span>
          </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('reservation.product')" prop="product.name" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column :label="$i18n.t('reservation.reservedAt')" prop="created_at" sortable >
        <template slot-scope="scope">
          <span v-if="scope.row.date">{{_moment(scope.row.date,'DD-MM-YYYY')}}</span>
          <span v-if="scope.row.delayed">{{$t('reservation.toCome')}}</span>
          <span v-if="scope.row.intent">{{$t('reservation.intent')}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('reservation.limitDate')" prop="limit_date" sortable >
        <template slot-scope="scope">
          <span v-if="scope.row.limit_date">{{_moment(scope.row.limit_date,'DD-MM-YYYY')}}</span>
          <span v-else> -- </span>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('reservation.qtyReserved')" prop="qty" sortable width="120">
      </el-table-column>
      <el-table-column :label="$i18n.t('reservation.qtyAvailable')" prop="quantity.qty_available" sortable width="120">
      </el-table-column>
      <el-table-column width="150" v-if="controls">
        <template slot-scope="scope">
          <el-button-group>
           <el-button type="primary" icon="el-icon-edit" size="mini" @click="$emit('edit',scope.row)"></el-button>
           <!-- <el-button type="primary" icon="el-icon-check" size="small" @click="handleConfirm(scope.row.id)"></el-button> -->
           <el-button type="primary" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)"></el-button>
         </el-button-group>
        </template>
      </el-table-column>
    </el-table>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import ReservationUtil from '@/utils/reservation-util'
import PortausLink from '@/components/portaus-link'
export default {
  name: 'reservation-table',
	props: {
    reservations : Array,
    height : {
      type : String,
      default : "232"
    },
    showCustomer : {
      type : Boolean,
      default : true,
    },
    showRep : {
      type : Boolean,
      default : true
    },
    loading : {
      type : Boolean,
      default : true,
    },
    controls : {
      type : Boolean,
      default :true
    }
	},
  data() {
    return {
      user : null
    };
  },components: {
    PortausLink
  },
  watch : {
    // type : function(newVal, oldVal){
    //   if(newVal!=oldVal){
    //     this.fetchSalesOrders();
    //   }
    // }
  },
	methods: {
    qtyValid (reservation) {
      return ReservationUtil.isQuantityValid(reservation);
    },
    handleConfirm(reservationId){
      this.$message.warning("Cette fonctionnalité n'est pas encore disponible");
    },
    customerName(customer){
      return customer.usual_name!=null?customer.usual_name:customer.name;
    },
      _diffDate(dateTimeFrom, measure='days',dateTimeToDefault=null){
      let dateTimeTo = dateTimeToDefault==null?moment():moment(dateTimeTo, measure);
      return moment(dateTimeFrom).diff(dateTimeTo, measure);
    },
    formatNbJours(nbJours){
      if(nbJours==0){
        return "Aujourd'hui";
      }else{
        if(nbJours<0) return (nbJours*-1)+ " jours";
        return nbJours+ " jours";
      }
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    },
    handleDelete(reservationId){
      this.$emit('delete',reservationId);
    },
    openCustomer(customerId){
        var index='/customers/'+customerId+'?activeTab=reservations';
        this.$router.push(index);
      },
	},
	computed: {
    ...mapGetters('reservations', ['isNegative','isIntermediary','isPositive'])
	}
}
</script>
<style lang="scss" scoped>




</style>
